const zoomCursorTargetSelector = '.vitava-zoom-cursor-target';

document.addEventListener('pointermove', (event) => {
  if (event.pointerType !== 'mouse') return;

  const zoomCursorTarget = event.target.closest(zoomCursorTargetSelector);
  if (!zoomCursorTarget) return;

  const bounds = zoomCursorTarget.getBoundingClientRect();

  zoomCursorTarget.style.setProperty('--vitava-zoom-cursor-x', `${event.clientX - bounds.left}px`);
  zoomCursorTarget.style.setProperty('--vitava-zoom-cursor-y', `${event.clientY - bounds.top}px`);
  zoomCursorTarget.classList.add('is-zoom-cursor-visible');
});

document.addEventListener('pointerout', (event) => {
  const zoomCursorTarget = event.target.closest(zoomCursorTargetSelector);
  if (!zoomCursorTarget || zoomCursorTarget.contains(event.relatedTarget)) return;

  zoomCursorTarget.classList.remove('is-zoom-cursor-visible');
});

document.addEventListener('scroll', () => {
  document.querySelectorAll(`${zoomCursorTargetSelector}.is-zoom-cursor-visible`).forEach((zoomCursorTarget) => {
    zoomCursorTarget.classList.remove('is-zoom-cursor-visible');
  });
}, { passive: true });
